export default {
    layout: {
        loading: 'Negociação em andamento',
        trading: 'Negociação em andamento'
    },

    footer: {
    },

    menu: {
        home: 'Início',
        staking: 'Matriz',
        port: 'PORT',
        internet: 'Rede',
        me: 'Minha Conta',
    },

    header: {
        selectLang: 'Selecionar idioma',
        close: 'Fechar',
        trading: 'Negociação',
        dashboard: 'Painel',
        subscribeMatrix: 'Assinar Matriz',
        portTaskCenter: 'Central de Tarefas PORT',
        network: 'Rede',
        apiBinding: 'Vinculação de API',
        gridTree: 'Árvore de Rede',
        account: 'Conta',
        documents: 'Documentos e Whitepaper',
        personalCenter: 'Centro Pessoal',
        language: 'Idioma'
    },

    home: {
        recently1: 'Comunidade',
        staticrewares: 'Estático',
        recentlyName: 'Livro Razão',
        recentlyInfo: 'Detalhes dos Ganhos',
        dataUpdate: 'Atualização de Dados',
        realtime: 'Tempo Real · BSC',

        totalRevenue: 'Receita Total (USDT)',
        today: 'Hoje',
        totalTradingVolume: 'Volume Total de Negociação',
        todayEarn: 'Ganho Hoje',

        share: 'Compartilhar com Amigos',
        shareDesc: 'Compartilhe seus ganhos e convide para ganhar recompensas',

        directReferrals: 'Indicações Diretas',
        teamMembers: 'Membros da Equipe',
        thisWeek: 'Esta Semana',

        copy: 'Copiar',

        recently: 'Ganhos Recentes',
        netIncome: 'Lucro Líquido',
        dailyAverage: 'Média Diária',

        quantitativeIncome: 'Quantitativo',
        recommend: 'Indicação',
        port: 'PORT',
        bonus: 'Bônus',

        all: 'Todos',
        todayTitle: 'Hoje',

        loadingMore: 'Carregar Anteriores',

        recommendBonus: 'Bônus de Indicação',
        portTaskPassed: 'Tarefa PORT Concluída',

        myProfit: 'Meu Lucro/Prejuízo',

        earningOnBitDeep: 'Estou ganhando no BitDeep',

        totalRevenueUsdt: 'Receita Total · USDT',

        consecutiveDays: 'Dias Consecutivos',

        scanToJoin: 'Escaneie para Participar',

        uid: 'UID',

        referralBonus: 'Bônus de Indicação',

        shareTo: 'Compartilhar em',

        eachReferral: 'Recompensa por Indicação',

        screenshotAndShare: 'Capturar Tela e Compartilhar',

        saveShareEarn: 'Salvar · Compartilhar · Ganhar',

        period: 'Período',

        netProfit: 'Lucro Líquido',

        quantReward: 'Recompensa Quantitativa',

        dailyBonus: 'Recompensa Diária PORT',

        close: 'Fechar',

        permission: 'Permissão',

        onlyEnable: 'Habilitar Apenas',

        enterBitgetUid: 'Digite o UID da Bitget',

        slogan: 'Código',

        document: 'Documento',

        days: 'Dias',

        taskText: 'Tarefa',

        minutes: 'Minutos',

        decentralizedPortTech:
            'Arquitetura tecnológica PoRT descentralizada, tokenomics BGB e matriz de incentivos de dupla área.',

        auditReport: 'Relatório de Auditoria',

        faqSupport: 'FAQ e Suporte',

        telegram: 'Telegram',

        piece: 'Un.',

        faq: 'Perguntas Frequentes',

        faq1: 'Como vincular a API da Bitget?',

        faq1Desc:
            'Acesse Bitget → Configurações → Gerenciamento de API, obtenha a API Key e Secret. Habilite apenas a negociação Spot e nunca habilite saque. Cole as chaves no DApp BitDeep. Após uma negociação de teste de 1U, a conta será ativada.',

        faq2: 'O que é PoRT (Proof of Real Trading)?',

        faq2Desc:
            'PoRT é o mecanismo central de "Negociar para Minerar". Os usuários executam automaticamente compras e vendas rápidas de ativos específicos (como BGB) via API Bitget. Quando o volume ultrapassa 50% do valor do staking, o sistema valida e libera os ganhos diários.',

        faq3: 'Preciso acompanhar o mercado manualmente todos os dias?',

        faq3Desc:
            'Não. Após vincular a API, o sistema executará automaticamente as tarefas de negociação em uma janela de 24 horas. Você pode verificar o status no menu PoRT.',

        faq4: 'Qual a diferença entre ALPHA e SIGMA?',

        faq4Desc:
            'ALPHA (Iniciante): staking de 500 U, rendimento diário de 0,3% a 1,3%, limitado a 1 pacote. SIGMA (Profissional): staking de 1.000 U, rendimento diário de 0,6% a 1,6%, até 5 pacotes.',

        faq5: 'Meus fundos estão seguros? A plataforma pode movimentar meu dinheiro?',

        faq5Desc:
            'Seus fundos permanecem 100% em sua conta Bitget. A API autoriza apenas leitura e negociação Spot. O sistema não pode sacar ou transferir seu capital.',

        faq6: 'Quando os ganhos diários são liquidados?',

        faq6Desc:
            'Após a validação do PoRT, os ganhos serão liquidados no dia seguinte. O sistema distribuirá automaticamente USDT e 10x pontos Deep.',

        faq7: 'Como é calculado o bônus de indicação?',

        faq7Desc:
            'Para cada conta válida indicada: ALPHA (500U) gera 1 USDT/dia e SIGMA (1000U) gera 2 USDT/dia, até o final do ciclo da conta.',

        faq8: 'Como atualizar o nível (D1–D7)?',

        faq8Desc:
            'O upgrade depende do desempenho da equipe. Por exemplo: D1 requer 2.000 U, D3 requer 15.000 U e D7 requer 3 milhões U. Quanto maior o nível, maior a recompensa diferencial.',

        faq9: 'Quantos dias dura um ciclo? O que acontece após o vencimento?',

        faq9Desc:
            'Cada ciclo dura 28 dias. Após o vencimento, você pode continuar fazendo staking e os rendimentos serão distribuídos de acordo com a validação diária do PoRT.',

        faq10: 'Existe taxa de saque?',

        faq10Desc:
            'Não há taxa de saque. As taxas são revertidas ao pool LP para fortalecer o ecossistema.',

        bigArea: 'Área Maior',

        smallArea: 'Área Menor',

        enterWithdrawAmount: 'Digite a quantidade para saque',

        available: 'Disponível',

        totalAmount: 'Valor Total',

        confirmWithdraw: 'Confirmar Saque',

        withdrawRecord: 'Histórico de Saques',

        withdrawn: 'Retirado',

        quickStartGuide: 'Guia Rápido',

        whitepaperGuide: 'Whitepaper e Guia',

        whitepaper: 'Whitepaper',

        downloadPdf: 'Baixar'
    },
        staking: {
        selectPackage: 'Assinar Matriz',

        alpha: 'ALPHA',
        beginner: 'Iniciante',

        sigma: 'SIGMA',
        professional: 'Profissional',

        popular: 'Mais Popular',

        dailyReturn: 'Recompensas da Tarefa',

        teamDepth: 'Profundidade da Equipe',

        limitPurchase: 'Limite de Compra',

        layer: 'Camada',

        copy: 'Un.',

        autoRenew: 'Renovação Automática ao Vencer',

        autoReinvest: 'Margem de renovação automática',

        subscribeAlpha: 'Assinar ALPHA',

        subscribeSigma: 'Assinar SIGMA',

        stakedAmount: 'Margem',

        stakedAmount2: 'Período',

        stakedAmount3: 'Ganhos Acumulados',

        stakingTime: 'Horário de participação',

        maturityTime: 'Data de Vencimento',

        redeem: 'Resgatar',

        renew: 'Renovar',

        autoRenewActive: 'Renovação Automática Ativada',

        autoRenewInactive: 'Renovação Automática Desativada',

        smartContract:
            'Custodiado por contrato Margem. O fundo de tarefas permanece bloqueado por 28 dias e será desbloqueado ao término do período.',
    },

    me: {
        account: 'Conta',

        my: 'Minha Conta',

        staked: 'Participou',

        staked1: 'Margem',

        points: 'Pontos',

        consecutive: 'Dias Consecutivos',

        withdraw: 'Sacar',

        language: 'Idioma',

        simplifiedChinese: 'Chinês Simplificado',

        disconnectWallet: 'Desconectar Carteira',

        level: 'Nível',

        joinDate: 'Data de Entrada',

        bdId: 'BD-ID'
    },

    bindapi: {

        apiBinding: 'Vinculação de API',

        bindDesc:
            'Vincule a API da sua corretora para autorizar negociações quantitativas',

        apiKey: 'API Key',

        apiSecret: 'API Secret',

        exchange: 'Corretora',

        futures: 'Futuros',

        spot: 'Spot',

        readOnly: 'Somente Leitura',

        bind: 'Vincular',

        riskNote:
            'A API é usada apenas para sincronização de dados de negociação. Nenhuma informação sensível será armazenada.',

        apiConnection: 'Conexão API',

        bindExchangeApi: 'Vincular API da Corretora',

        bitDeepRead:
            'O BitDeep lê o fluxo de ordens da sua conta CEX para verificar a Prova de Negociação Real (PoRT).',

        noWithdraw:
            'Nunca teremos acesso à função de saque da sua conta.',

        securityTip:
            'Aviso de Segurança · Leia atentamente',

        close: 'Fechar',

        withdraw: 'Saque',

        permission: 'Permissão',

        onlyEnable: 'Habilitar Apenas',

        spotTrading: 'Negociação Spot',

        read: 'Leitura',

        recommendedPartner: 'Parceiro Recomendado',

        zeroFee: '0% de Taxa',

        activated: 'Ativado',

        classicAccount: 'Conta Clássica',

        unifiedAccount: 'Conta Unificada',

        bindBitgetApi: 'Vincular API da Bitget',

        upcoming: 'Em Breve',

        underAudit: 'Integração em Auditoria',

        expected: 'Previsto'
    },

    port: {

        portTaskCenter: 'Central de Tarefas PORT',

        dailyTask: 'Tarefa Diária',

        verify: 'Verificar',

        completed: 'Concluído',

        incomplete: 'Incompleto',

        verifyStandard: 'Critério de Verificação',

        tradingVolume: 'Volume de Negociação',

        today: 'Hoje',

        deadline: 'Prazo Final',

        reward: 'Recompensa',

        startVerify: 'Iniciar Verificação',

        verifying: 'Verificando',

        verified: 'Verificado',

        insufficient: 'Não Atingido',

        viewDetails: 'Ver Detalhes',

        taskList: 'Lista de Tarefas',

        allTasks: 'Todas as Tarefas',

        completedTasks: 'Concluídas',

        pendingTasks: 'Pendentes',

        proofOfRealTrading: 'Prova de Negociação Real',

        todayTask: 'Tarefa de Hoje',

        todayStaticIncome: 'Recompensas das tarefas de hoje',

        points: 'Pontos',

        todayWindowClosesAt: 'Janela de Hoje Fecha em',

        checkTaskStatus: 'Verificar Status da Tarefa',

        teamProgress: 'Progresso da Equipe · Hoje',

        realtimePortCompletion:
            'Conclusão PORT em Tempo Real',

        completedText: 'Concluído',

        pendingText: 'Pendente',

        realtimeApiValidationFlow:
            'Tempo Real · API · Fluxo de Verificação',

        rewardRemark1: 'Dividendos Globais',

        rewardRemark2: 'Bônus Diferencial',

        rewardRemark3: 'Bônus de Indicação',

        rewardRemark4: 'Recompensa da Tarefa',

        rewardRemark5: 'Tarefa PoRT Concluída',
    },
        internet: {

        network: 'Rede',

        treeBrowser: 'Árvore de Rede',

        searchAddress: 'Pesquisar endereço 0x... ou BD-ID',

        totalTradingVolume: 'Volume Total de Negociação',

        members: 'Membros',

        networkStructure: 'Estrutura da Rede',

        allLevels: 'Todos os Níveis',

        addRemark: 'Adicionar Observação',

        enterRemark: 'Digite uma observação',

        cancel: 'Cancelar',

        confirm: 'Confirmar',
        alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
    },

    withdraw: {

        withdraw: 'Sacar',

        usdtAsset: 'Ativos USDT',

        withdrawAmount: 'Valor do Saque',

        availableBalance: 'Saldo Disponível',

        fee: 'Taxa',

        actualArrival: 'Valor Recebido',

        submit: 'Enviar',

        withdrawSuccess: 'Sucesso',

        withdrawFailed: 'Falha',

        processing: 'Processando',

        completed: 'Concluído',

        withdrawHistory: 'Histórico de Saques'
    },

    popup: {

        taskUnfinished: 'Tarefa Não Concluída',

        taskUnfinishedDesc:
            'Os dados de negociação não atingiram o padrão de validação PoRT de hoje.',

        todayTradingVolume: 'Volume de Negociação de Hoje',

        remaining: 'Restante',

        toComplete:
            'para concluir a tarefa de hoje',

        tradingVolumeThreshold: '',

        deadline:'Tempo restante até o encerramento da tarefa',

        tryAgain: 'Tente Novamente Mais Tarde',

        goTrade: 'Ir para Negociar',

        taskCompleted: 'Validação da Tarefa Concluída',

        taskCompletedDesc: 'A Prova de Negociação PoRT de hoje foi registrada com sucesso na blockchain.',

        rewardIssued: 'Recompensa Distribuída',

        complete: 'Concluir',

        shareTitle: 'Compartilhar Convite',

        shareDesc:
            'Convide amigos para se registrar e ambos receberão recompensas.',

        referralLink: 'Link de Convite',

        qrCode: 'Código QR',

        copyLink: 'Copiar Link',

        notask:'Sem tarefas hoje',
        notaskDesc:'Atualmente não há tarefas de negociação PoRT pendentes',
    }
};